import styles from '../../styles/Search.module.css';

const SearchBar = ({ searchTxt, onchangevalue, doSearch, setPreciseMode }) => {
  const startSearch = () => {
    // Manual search always starts from precise mode.
    setPreciseMode(true);
    doSearch();
  };

  return (
    <div className={styles.mainBanner}>
      <div className={styles.searchInputHolder}>
        <input
          type="text"
          name="search"
          value={searchTxt}
          className={styles.inputField}
          onChange={onchangevalue}
          onKeyDown={(e) => e.key === 'Enter' && startSearch()}
        />
        <input
          type="submit"
          value="搜尋"
          className={styles.searchBtn}
          onClick={startSearch}
        />
      </div>
    </div>
  );
};

export default SearchBar;